import React, { useEffect, useState } from "react";
import styles from "../../assets/css/admin/layout.module.css"
import "../../assets/css/admin/allAdmins.module.css"
import SideBar from "./SideBar";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import moment from "moment";
import {useAuth} from "../../AuthContext"
import { useSidebar } from "../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'


const PaymentDetails = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [payments, setPayments] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalPayments, setTotalPayments] = useState(0);

    const getPayments = async (pageNum = page, limit = entriesPerPage) => {
        try {
            const res = await axios.get(`${baseUrl}/payment/all?page=${pageNum}&limit=${limit}`);
            setPayments(res.data.payments);
            setTotalPages(res.data.totalPages);
            setTotalPayments(res.data.total);
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getPayments(page, entriesPerPage)
    }, [page, entriesPerPage])

    const deletePayment = (p) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.post(`${baseUrl}/payment/delete/?id=${p.transactionId}`)
                        .then(res => {
                            getPayments(page, entriesPerPage)
                            swal(`${res.data.message}`, {
                                icon: "success",
                            });
                        }
                        )
                        .catch(err=>{
                            swal(`${err.response.data.message}`, {
                                icon: "error",
                            })
                        })
                }
            });
    }

    const renderPageNumbers = () => {
        const pages = [];
        const visibleRange = 2;
    
        let start = Math.max(1, page - visibleRange);
        let end = Math.min(totalPages, page + visibleRange);
    
        if (start > 1) {
          pages.push(1);
          if (start > 2) pages.push("…");
        }
    
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
    
        if (end < totalPages) {
          if (end < totalPages - 1) pages.push("…");
          pages.push(totalPages);
        }
    
        return pages.map((num, i) =>
          num === "…" ? (
            <span key={i} className="mx-1">…</span>
          ) : (
            <button
              key={i}
              onClick={() => setPage(num)}
              className={`btn btn-sm mx-1 ${num === page ? "btn-primary" : "btn-outline-primary"}`}
            >
              {num}
            </button>
          )
        );
      };

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
            <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Payment Details
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className="container"
                    style={{ backgroundColor: "white", padding: "40px" }}
                >
                    <h4 className="mb-4"> All Payments</h4>
                    <div style={{overflowX:'scroll'}}>
                        <table>
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <td>Transaction ID</td>
                                    <td>Paid On</td>
                                    <td>Student Name</td>
                                    <td>Email</td>
                                    <td>Status</td>
                                    <td>Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                {payments.length > 0 &&
                                    payments.map((p, i) => (
                                        <tr key={i}>
                                            <td>{(page - 1) * entriesPerPage + i + 1}</td>
                                            <td>{p.transactionId}</td>
                                            <td>{moment(p.updatedAt).format('MMM Do YYYY hh:mm:ss a')}</td>
                                            <td>{p.studentId?.name || p.studentDetails?.name}</td>
                                            <td>{p.studentId?.email || p.studentDetails?.email}</td>
                                            <td>{p.status==='SUCCESS'&&<span className="badge badge-pill p-2 badge-success">{p.status}</span>}
                                            {p.status==='PENDING'&&<span className="badge badge-pill p-2 badge-warning">{p.status}</span>}
                                            </td>
                                            
                                            <td>
                                                {/* <Link to={`/admin/course/edit/${a.courseID}`}><button className="btn btn-success btn-sm m-1">Edit</button></Link>&nbsp; */}
                                                <button onClick={() => deletePayment(p)} className="btn btn-danger btn-sm m-1 p-1">Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
                        <div className="d-flex flex-wrap gap-3">
                        <div>Showing page {page} of {totalPages} ({totalPayments} entries)</div>
                        <div>
                            <label className="me-2">Entries per page:</label>
                            <select
                                value={entriesPerPage}
                                onChange={(e) => {
                                    setEntriesPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[5, 10, 20, 50].map(size => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                        </div>
                        <div>
                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                onClick={() => setPage(p => Math.max(p - 1, 1))}
                                disabled={page === 1}
                            >
                                Prev
                            </button>
                            {renderPageNumbers()}
                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                onClick={() => setPage(p => Math.min(p + 1, totalPages))}
                                disabled={page === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default PaymentDetails
